module.exports = __webpack_public_path__ + "static/media/OrthoActive.e65198d5.png";